import React from 'react';
import { Form } from './Form';

import './Form.css';


export const FormRegisterAdmin = () => {
  return (
    <div id="formRegisterContainer">
      <Form />
    </div>
  );
};
